import { render, staticRenderFns } from "./QuizDetail.vue?vue&type=template&id=42d0155e&"
import script from "./QuizDetail.vue?vue&type=script&lang=js&"
export * from "./QuizDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuizDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports